import { useState } from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Box, Center, Image, Spinner, Stack
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import {
  getProfileItem,
  setOpenFriendRequest,
  setProfileItemId,
  markersSelectors,
  usersSelectors
} from 'store'
import { PENDING } from 'utils/constants'
import { v4 as uuid } from 'uuid'

import { ConnectRequestModal } from './ConnectRequestModal'

export const BlockedRequestItems = ({
  notifications,
  selectId,
  handleNotificationButton
}) => {
  const dispatch = useDispatch()
  const {
    adminNotifRequest,
    getAdminNotificationsStatus,
    getBlogPreferenceStatus,
    getEngagementItemsStatus,
    getPostsStatus,
    getProfileItemStatus,
    getSavedEventsStatus,
    openFriendRequest,
    profileItemId,
    postMakeNotificationSeenAllStatus,
    postMakeNotificationSeenStatus
  } = useSelector(usersSelectors)

  const {
    getEventDataStatus,
    singleMarkerUpdateStatus
  } = useSelector(markersSelectors)

  const isClickable = (item) => {
    if (
      item?.sender_id === profileItemId > 0
      || (
        getProfileItemStatus === PENDING
        && profileItemId
      )
      || getPostsStatus === PENDING
      || postMakeNotificationSeenStatus === PENDING
      || postMakeNotificationSeenAllStatus === PENDING
      || getProfileItemStatus === PENDING
      || getEventDataStatus === PENDING
      || getEngagementItemsStatus === PENDING
      || getBlogPreferenceStatus === PENDING
      || singleMarkerUpdateStatus === PENDING
      || getSavedEventsStatus === PENDING
      || sessionStorage.getItem('openProfileAfterAnimation')
      || sessionStorage.getItem('openEventAfterAnimation')
    ) {
      return 'none'
    }

    return 'auto'
  }

  const isFaded = (item) => {
    if (
      item?.sender_id === profileItemId > 0
      || (
        getProfileItemStatus === PENDING
        && profileItemId
      )
      || getPostsStatus === PENDING
      || postMakeNotificationSeenStatus === PENDING
      || postMakeNotificationSeenAllStatus === PENDING
      || getProfileItemStatus === PENDING
      || getEventDataStatus === PENDING
      || getEngagementItemsStatus === PENDING
      || getBlogPreferenceStatus === PENDING
      || singleMarkerUpdateStatus === PENDING
      || getSavedEventsStatus === PENDING
      || sessionStorage.getItem('openProfileAfterAnimation')
      || sessionStorage.getItem('openEventAfterAnimation')
    ) {
      return '0.7'
    }

    return '1'
  }

  const handleClick = (item) => {
    if (
      localStorage.getItem('is-notif-modal-open') === 'false'
      && postMakeNotificationSeenStatus !== PENDING
    ) {
      let waitTime = 0
      if (
        document.querySelector('#chakra-modal-blog-drawer')
        || document.querySelector('#chakra-modal-event-drawer')
      ) {
        document.querySelector('#force-close-blog-drawer')?.click()
        document.querySelector('#force-close-event-drawer')?.click()
        waitTime = 900
        dispatch(getProfileItem.pending())
      }

      setTimeout(() => {
        if (item?.sender_id === profileItemId) {
          dispatch(getProfileItem(item?.sender_id))
        } else {
          dispatch(getProfileItem.pending())
          dispatch(setProfileItemId(item?.sender_id))
        }

        localStorage.setItem('isBlockedNotification', 'true')
        localStorage.setItem('friendReqID', item?.friend_request_id)
        sessionStorage.setItem('id', item?.sender_id)
        setTimeout(() => document.getElementById(item?.sender_id)?.scrollIntoView({
          block: 'nearest'
        }), 50)
      }, waitTime)
    }
  }

  useState(() => {
    if (
      openFriendRequest
      && adminNotifRequest !== null
      && getAdminNotificationsStatus !== PENDING
    ) {
      const friendReq = notifications.find((item) => item?.sender_id === openFriendRequest)
      dispatch(setOpenFriendRequest(null))

      setTimeout(() => handleClick(friendReq), 1000)
    }
  }, [openFriendRequest])

  return (
    <Stack
      spacing="55px"
      id="connection-request-list"
      paddingBottom={notifications.length > 3 ? '5px' : null}
      top="-1091px"
      marginLeft="5px"
      marginRight="5px"
      sx={{
        overflowX: 'auto',
        display: 'flex',
        flexDirection: 'row',
        gap: '0px',
        overflowAnchor: 'auto !important'
      }}
      css={{
        '&::-webkit-scrollbar': {
          width: '4px',
          height: '10px',
          display: 'block'
        },
        '&::-webkit-scrollbar-track': {
          width: '6px'
        },
        '&::-webkit-scrollbar-thumb': {
          borderRadius: '24px',
          background: 'rgba(255, 215, 0, 1)'
        }
      }}
    >
      {notifications.map((item) => (
        <Stack key={uuid()} id={item?.sender_id}>
          <Box
            key={uuid()}
            cursor="pointer"
            onClick={() => handleClick(item)}
            sx={{
              minWidth: '118px',
              marginTop: '5px'
            }}
            data-name="notificationItem"
            position="relative"
            pointerEvents={isClickable(item)}
            opacity={isFaded(item)}
          >
            {getProfileItemStatus === PENDING && item?.sender_id === profileItemId
              ? (
                <Center position="absolute">
                  <Spinner
                    key={uuid()}
                    width="60px"
                    height="60px"
                    position="sticky"
                    marginLeft="25px"
                    marginTop="25px"
                    zIndex={5}
                  />
                </Center>
              ) : null }
            <Image
              key={uuid()}
              width="108px"
              height="108px"
              opacity={
                getProfileItemStatus === PENDING
                && item?.sender_id === profileItemId ? 0.7 : 1
              }
              objectFit="cover"
              src={item.profile_picture ?? ImagesPng.DefaultImage}
              alt={item?.title}
              borderRadius="5px"
            />
          </Box>
          <ConnectRequestModal
            requestId={item?.sender_id}
            selectId={selectId}
            handleNotificationButton={handleNotificationButton}
            getProfileItemStatus={getProfileItemStatus}
            friendRequestID={item?.friend_request_id}
            notifications={notifications}
          />
        </Stack>
      ))}
    </Stack>
  )
}
